// extracted by mini-css-extract-plugin
export default {"timelineBlock":"style_timelineBlock__ZD+b0","yearBlock":"style_yearBlock__-VerF","yearLabel":"style_yearLabel__h0U5E","yearContent":"style_yearContent__VXKVV"};